/* ═══════════════════════════════════════════════════════
   GROOVE / VICTAULIC COUPLING REFERENCE
   ═══════════════════════════════════════════════════════ */

export const grooveHeaders = ["Pipe Size", "Groove OD", "Groove Width", "Groove Depth", "Coupling Model", "Bolt Size"];
export const grooveRows: (string | number)[][] = [
  ['1"',    1.375, "3/8\"",  0.052, "Style 75/77", "3/8\"×1½\""],
  ['1¼"',   1.660, "3/8\"",  0.052, "Style 75/77", "3/8\"×1½\""],
  ['1½"',   1.900, "3/8\"",  0.052, "Style 75/77", "3/8\"×1½\""],
  ['2"',    2.375, "3/8\"",  0.052, "Style 75/77", "3/8\"×2\""],
  ['2½"',   2.875, "3/8\"",  0.052, "Style 75/77", "½\"×2\""],
  ['3"',    3.500, "3/8\"",  0.052, "Style 75/77", "½\"×2½\""],
  ['4"',    4.500, "3/8\"",  0.052, "Style 75/77", "½\"×2½\""],
  ['5"',    5.563, "½\"",    0.065, "Style 77",    "⅝\"×3\""],
  ['6"',    6.625, "½\"",    0.065, "Style 77",    "⅝\"×3\""],
  ['8"',    8.625, "½\"",    0.065, "Style 77",    "¾\"×3½\""],
  ['10"',  10.750, "½\"",    0.065, "Style 77",    "¾\"×4\""],
  ['12"',  12.750, "½\"",    0.065, "Style 77",    "¾\"×4½\""],
];

/* ═══════════════════════════════════════════════════════
   WELD PREP REFERENCE TABLE
   ═══════════════════════════════════════════════════════ */

export const weldPrepHeaders = ["Pipe Size", "Wall (Sch 40)", "Bevel Angle", "Root Gap", "Root Land", "Preheat"];
export const weldPrepRows: (string | number)[][] = [
  ['½"–¾"',   "0.109\"–0.113\"", "37.5°±2.5°", "1/16\"–3/32\"", "1/16\"±1/32\"", "None"],
  ['1"',      "0.133\"",        "37.5°±2.5°", "1/16\"–3/32\"", "1/16\"±1/32\"", "None"],
  ['1¼"–1½"', "0.140\"–0.145\"", "37.5°±2.5°", "1/16\"–3/32\"", "1/16\"±1/32\"", "None"],
  ['2"',      "0.154\"",        "37.5°±2.5°", "3/32\"",        "1/16\"±1/32\"", "None (≤32°F: 200°F)"],
  ['2½"–3"',  "0.203\"–0.216\"", "37.5°±2.5°", "3/32\"",        "1/16\"±1/32\"", "50°F min"],
  ['4"',      "0.237\"",        "37.5°±2.5°", "3/32\"",        "1/16\"±1/32\"", "50°F min"],
  ['5"–6"',   "0.258\"–0.280\"", "37.5°±2.5°", "3/32\"–1/8\"",  "1/16\"±1/32\"", "50°F min"],
  ['8"',      "0.322\"",        "37.5°±2.5°", "1/8\"",         "3/32\"±1/32\"", "200°F (>1\" wall)"],
  ['10"–12"', "0.365\"–0.375\"", "37.5°±2.5°", "1/8\"",         "3/32\"±1/32\"", "200°F (>1\" wall)"],
  ['14"–16"', "0.375\"",        "37.5°±2.5°", "1/8\"",         "3/32\"±1/32\"", "200°F (>1\" wall)"],
  ['18"–24"', "0.375\"",        "37.5°±2.5°", "5/32\"",        "3/32\"±1/32\"", "200°F+ recommended"],
];

/* ═══════════════════════════════════════════════════════
   COMBINED GROOVE & WELD PREP TABLE
   ═══════════════════════════════════════════════════════ */

export const grooveWeldHeaders = ["Pipe Size", "Category", "Detail 1", "Detail 2", "Detail 3", "Detail 4"];
export const grooveWeldRows: (string | number)[][] = [
  // Groove data: Detail1=Groove OD, Detail2=Width, Detail3=Coupling, Detail4=Bolt
  ...grooveRows.map(r => [r[0], "Groove", `OD ${r[1]}`, `W ${r[2]}`, String(r[4]), `Bolt ${r[5]}`]),
  // Weld prep: Detail1=Wall, Detail2=Bevel, Detail3=Gap, Detail4=Preheat
  ...weldPrepRows.map(r => [r[0], "Weld Prep", String(r[1]), String(r[2]), `Gap ${r[3]}`, String(r[5])]),
];
